__webpack_require__.p = "/ai-wysiwyg/onboarding/";